import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import './index.css';
import App from './App';
import { ENV } from './config/api_config';
import { CookiesProvider } from "react-cookie";
import './config/axiosGlobalInterceptor'; // Add this line
import { Integrations } from '@sentry/tracing';
import ChunkErrorBoundary from './ChunkErrorBoundary';

Sentry.init({
  dsn: 'https://4d0ceba2ce232afc006908eda994227a@o4510040685674496.ingest.us.sentry.io/4510040691376128',

  integrations: [
    new Integrations.BrowserTracing({
      // Configure which URLs should have tracing headers
      tracingOrigins: [
        "localhost",            // local dev
        "xgfy",                 // any URL containing xgfy
        "ninjacurate",          // any URL containing ninjacurate
        /^\//,                  // same-origin relative calls
      ],
    }),
  ],

  // 1.0 = capture all transactions (lower in prod, e.g. 0.1)
  tracesSampleRate: 1.0,

  // Scrub sensitive data
  sendDefaultPii: false,
  beforeSend(event) {
    if (event.request && event.request.data) {
      event.request.data = "<scrubbed>";
    }
    return event;
  },
});

// Global handler for JS chunk load errors that surface as unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const reason = event && event.reason ? event.reason : null;
  const message = reason && reason.message ? reason.message : '';
  const name = reason && reason.name ? reason.name : '';

  const isChunkError =
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError') ||
    name === 'ChunkLoadError';

  if (isChunkError) {
    try {
      const alreadyReloaded = sessionStorage.getItem('chunk-reload-done');
      if (!alreadyReloaded) {
        sessionStorage.setItem('chunk-reload-done', 'true');
        window.location.reload();
      }
    } catch (e) {
      window.location.reload();
    }
  }
});


ReactDOM.render(
  <CookiesProvider>
    <ChunkErrorBoundary>
      <App />
    </ChunkErrorBoundary>
  </CookiesProvider>,
  document.getElementById('root')
);

if (ENV === "PRODUCTION") console.log = function () { };
